import request from '@/utils/request'

export function getRaffleTimes(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/my/reward',
    method: 'post',
    params: data
  })
}

export function getDrawResult(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/draw',
    method: 'post',
    params: data
  })
}

export function putShare() {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/anniversary/celebration/share/wechat/friend',
    method: 'post',
  })
}



export function saveAddrInfo(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/recipient/address',
    method: 'post',
    data
  })
}

export function fetchCountDown(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/combined/purchase/count/down/screen/info',
    method: 'post',
    data
  })
}



export function getAddrInfo(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/recipient/address',
    method: 'get',
    params: data
  })
}

// 挽留时间
export function fetchScreenDetain(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/combined/purchase/count/down/screen/detain',
    method: 'post',
    params: data
  })
}

// 查询折扣vip状态接口（必须登录）



export function fetchEductionVip(query) {
  return request({
    url: '/articleCharge/queryEductionVip',
    method: 'get',
    params: query
  })
}
// http://k8s-dev.wogoo.com/server/articleCharge/queryEductionVip

// /chaos/api/v1/activity/term/award/list






// WEBPACK FOOTER //
// ./src/views/activity_136/api.js